<main class="main-component">
    <p>new-claim works!</p>
</main>